import { useMemo } from "react";
import { getAdMetadata, parseAdMetadata } from "../util/adMetadata";

// Simple hook to get ad metadata (full query string)
export const useAdMetadata = () => {
  return useMemo(() => {
    return getAdMetadata();
  }, []);
};

// Hook to get individual marketing parameters from ad metadata
export default function useMarketingIds() {
  const adMetadata = useAdMetadata();

  return useMemo(() => {
    return adMetadata ? parseAdMetadata(adMetadata) : {};
  }, [adMetadata]);
}
